<script lang="ts">
import { defineComponent } from "vue";
import _ from "@/boot/lodash";
import type { RenderContext } from "vue";

export default defineComponent({
  functional: true,
  props: {
    hasError: { type: Boolean, required: true },
    isLoading: { type: Boolean, default: false }
  },
  render(h, { props, listeners, children }: RenderContext) {
    if (props.hasError) {
      return h("request-error", {
        props: {
          isLoading: props.isLoading
        },
        on: {
          click: e => {
            const retry = listeners["retry"];

            if (_.isFunction(retry)) {
              retry(e);
            }
          }
        }
      });
    } else {
      return children;
    }
  }
});
</script>
